import {CLOSE, MODAL_CLOSE_TEXT} from "../../utils/constants";
import {Modal} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import {ReactComponent as ModalClose} from "../../images/modal_close.svg";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import YuJaButton from "../standardization/YuJaButton";
import {UserApiCalls} from "../../apis/UserApiCalls";
import {useSession} from "../../hooks/useSession";
import {usePPTWebView} from "../../hooks/usePPTWebView";
import {ReportApiCalls} from "../../apis/ReportApiCalls";
import DOMPurify from "dompurify";

export default function MonthlyUsageModal() {
    const windowDimensions = useWindowDimensions();
    const {width} = windowDimensions;
    const [show, setShow] = useState(false);
    const {loadUser, updateMonthlyUsage} = UserApiCalls();
    const {getMonthlyUsage} = ReportApiCalls();
    const {parseSessionToken} = useSession();
    const {isPPTPage, parseToken} = usePPTWebView();
    const [monthlyUsageHtml, setMonthlyUsageHtml] = useState("");

    const {institutionId, userId} = isPPTPage() ? parseToken() : parseSessionToken();


    useEffect(() => {
        const now = new Date();
        const oneMonthAgo = new Date();
        oneMonthAgo.setUTCMonth(now.getMonth() - 1);
        let yearMonth = oneMonthAgo.toISOString().substring(0, 7);

        let promise1 = loadUser(institutionId, userId);
        let promise2 = getMonthlyUsage(yearMonth);
        Promise.all([promise1, promise2]).then(([res, htmlString]) => {
            if (!Object.keys(res).length || !htmlString) {
                return;
            }


            const firstDayOfCurMonth = new Date();
            firstDayOfCurMonth.setUTCDate(1);
            firstDayOfCurMonth.setUTCHours(0, 0,0, 0);

            let { monthlyUsageDate = ""} = res;

            if (!monthlyUsageDate || new Date(monthlyUsageDate) < firstDayOfCurMonth) {
                setMonthlyUsageHtml(htmlString);
                setShow(true);
            }

        })
    }, []);


    useEffect(() => {
        const targetDiv = document.getElementById("highlightUsageTarget");
        if(!show || !monthlyUsageHtml || !targetDiv) {
            return;
        }

        targetDiv.innerHTML = DOMPurify.sanitize(monthlyUsageHtml, {
            FORCE_BODY: true,
        });

        const el = targetDiv.querySelector('[style*="margin:0px auto"][style*="max-width:900px"]');
        if (!!el) {
            el.style.maxWidth = `${Math.min(0.9 * width, 900) - 100}px`;
        }

        targetDiv.querySelectorAll("tbody td").forEach(el => {
            el.style.setProperty("background-color", "transparent", "important");
        });

        // targetDiv.querySelectorAll("div.border").forEach(el => {
        //     el.style.overflow = "hidden";
        // });
        //
        // targetDiv.querySelectorAll('[style*="line-height:1"]').forEach(el => {
        //     el.style.lineHeight = "1.4";
        // });

    }, [windowDimensions, monthlyUsageHtml, show]);


    useEffect(() => {
        const handleKeyDownDropdown = (event) => {
            if (event.key !== "Tab") {
                return;
            }
            const container = document.querySelector(".monthly-highlight-usage-modal");
            if (!container) {
                return;
            }

            const focusableElements = container.querySelectorAll('[tabindex]:not([tabindex="-1"])');

            if (!container.contains(event.target)) {
                event.preventDefault();
                focusableElements[0].focus();
                return;
            }

            if (event.shiftKey) {
                for (let i = 0; i < focusableElements.length; i++) {
                    if (focusableElements[i] !== event.target) {
                        continue;
                    }
                    if (i === 0) {
                        event.preventDefault();
                        focusableElements[focusableElements.length - 1].focus();
                        return;
                    } else {
                        event.preventDefault();
                        focusableElements[i - 1].focus();
                        return;
                    }
                }
            } else {
                for (let i = 0; i < focusableElements.length; i++) {
                    if (focusableElements[i] !== event.target) {
                        continue;
                    }
                    if (i === focusableElements.length - 1) {
                        event.preventDefault();
                        focusableElements[0].focus();
                        return;
                    } else {
                        event.preventDefault();
                        focusableElements[i + 1].focus();
                        return;
                    }
                }
            }

        };

        if (!!show) {
            document.addEventListener("keydown", handleKeyDownDropdown);
        }

        return () => {
            document.removeEventListener("keydown", handleKeyDownDropdown);
        };
    }, [show]);


    const onClose = () => {
        setShow(false);
        const now = new Date().toISOString();
        updateMonthlyUsage(institutionId, userId, now);
    };

    return (
        <Modal
            show={show}
            backdrop={true}
            dialogClassName= {"monthly-highlight-usage-modal"}
        >
            <span
                tabIndex={0}
                aria-label={MODAL_CLOSE_TEXT}
                className="modal-close"
                style={{zIndex: 1}}
                onClick={onClose}
            >
                <ModalClose/>
            </span>
            <Modal.Body>
                <div
                    id={"highlightUsageTarget"}
                    style={{maxHeight: "calc(90vh - 60px)", overflow: "scroll", scrollbarWidth: "none"}}
                />
            </Modal.Body>
            <Modal.Footer>
                <YuJaButton type={"secondary"} onClick={onClose} style={{height: 35, width: 75}}>
                    {CLOSE}
                </YuJaButton>
            </Modal.Footer>
        </Modal>
    );
}